
  import { defineComponent } from 'vue';
  import { mapGetters, mapMutations } from 'vuex';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import calculationApi from '../api/Calculation';
  import CalculationForm from '../components/common/CalculationForm.vue';
  import CalculationPageWrapper from '../components/common/CalculationPageWrapper.vue';
  import { CALCULATION_COMMON_GETTERS_NAME, CALCULATION_COMMON_MUTATIONS_NAME } from '../store/calculationCommon/name';
  import { TCalculationActiveInfo, TUploadingDataStatus, UploadingDataStatusTypes } from '../types/calculation-common';

  export default defineComponent({
    name: 'GasRecalculation',
    components: { CalculationForm, CalculationPageWrapper },
    mixins: [security],
    data(): {
      isUploadingFile: boolean;
    } {
      return {
        isUploadingFile: false,
      };
    },
    computed: {
      ...mapGetters({
        uploadingDataStatus: CALCULATION_COMMON_GETTERS_NAME.getUploadingDataStatus,
      }),
      getUploadingDataStatus(): TUploadingDataStatus {
        return this.uploadingDataStatus as TUploadingDataStatus;
      },
      getIsFormLoading(): boolean {
        return (
          (this.getUploadingDataStatus.type === this.getType && this.getUploadingDataStatus.isProgress) ||
          this.isUploadingFile
        );
      },
      getType(): UploadingDataStatusTypes {
        return UploadingDataStatusTypes.GAS_RECALCULATION;
      },
    },
    methods: {
      ...mapMutations({
        setUploadingDataStatus: CALCULATION_COMMON_MUTATIONS_NAME.setUploadingDataStatus,
      }),
      async handleSubmitForm() {
        try {
          this.isUploadingFile = true;
          const processingId = (await calculationApi.startGasRecalculation()).data;

          const newUploadingDataStatus: TCalculationActiveInfo = {
            isProgress: true,
            type: this.getType,
            processingId,
          };

          this.setUploadingDataStatus(newUploadingDataStatus);
        } catch (error) {
          console.error(error);
        } finally {
          this.isUploadingFile = false;
        }
      },
    },
    mounted() {
      this.checkPermissionAndRedirect(constants.Permissions.ForeignTradeAnalyticsGasRecalculationUpload);
    },
  });
